var _defs, _path, _rect, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _polygon, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDishwasher(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M379.7,126.7h-104.5c-5.3,0-9.6-4.3-9.6-9.6,0,0,0,0,0,0,0,5.3,4.3,9.6,9.6,9.6h104.5c5.3,0,9.6-4.3,9.6-9.6s0,0,0,0c0,5.3-4.3,9.6-9.6,9.6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 495.2,
    y: 152.9,
    width: 0,
    height: 130.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M111.7,509c0,3,2.5,5.5,5.5,5.5h8.2c3,0,5.5-2.5,5.5-5.5v-5.5h-19.2v5.5Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.8,509c0,3,2.5,5.5,5.5,5.5h8.2c3,0,5.5-2.5,5.5-5.5v-5.5h-19.2v5.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M463.7,509c0,3,2.5,5.5,5.5,5.5h8.2c3,0,5.5-2.5,5.5-5.5v-5.5h-19.2v5.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M383.9,509c0,3,2.5,5.5,5.5,5.5h8.2c3,0,5.5-2.5,5.5-5.5v-5.5h-19.2v5.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M379.7,121.2h-104.5c-2.3,0-4.1-1.8-4.1-4.1,0,0,0,0,0,0,0,2.3,1.8,4.1,4.1,4.1h104.5c2.3,0,4.1-1.8,4.1-4.1s0,0,0,0c0,2.3-1.8,4.1-4.1,4.1Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M154.4,91c0-1.2.1-2.2.4-3.2l-45.6,9.5c-2.6.5-4.4,2.8-4.4,5.4v389.8c0,3,2.5,5.5,5.5,5.5h45.5c-1-1.6-1.5-3.5-1.5-5.5V91Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M489.8,85.5H165.3c-3,0-5.5,2.5-5.5,5.5v56.4h335.5v-56.4c0-3-2.5-5.5-5.5-5.5ZM389.3,117.2c0,5.3-4.3,9.6-9.6,9.6h-104.5c-5.3,0-9.6-4.3-9.6-9.6s0,0,0,0c0,0,0,0,0,0,0-5.3,4.3-9.6,9.6-9.6h104.5c5.3,0,9.6,4.3,9.6,9.6s0,0,0,0c0,0,0,0,0,0Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M489.7,80H165.3c-1.5,0-3,.3-4.3.9l-52.9,11c-5.1,1-8.7,5.6-8.7,10.8v389.8c0,4.6,2.9,8.6,6.9,10.2v6.3c0,6.1,4.9,11,11,11h8.2c6.1,0,11-4.9,11-11v-5.5h28.9v5.5c0,6.1,4.9,11,11,11h8.2c6.1,0,11-4.9,11-11v-5.5h182.9v5.5c0,6.1,4.9,11,11,11h8.2c6.1,0,11-4.9,11-11v-5.5h49.5v5.5c0,6.1,4.9,11,11,11h8.2c6.1,0,11-4.9,11-11v-5.5h1.4c6.1,0,11-4.9,11-11V91c0-6.1-5-11-11.1-11ZM130.9,509c0,3-2.5,5.5-5.5,5.5h-8.2c-3,0-5.5-2.5-5.5-5.5v-5.5h19.2v5.5ZM110.4,498h0c-3,0-5.5-2.5-5.5-5.5V102.7c0-2.6,1.8-4.8,4.4-5.4l45.6-9.5c-.3,1-.4,2.1-.4,3.2v401.5c0,2,.5,3.9,1.5,5.5h-45.5ZM190,509c0,3-2.5,5.5-5.5,5.5h-8.2c-3,0-5.5-2.5-5.5-5.5v-5.5h19.2v5.5ZM403.1,509c0,3-2.5,5.5-5.5,5.5h-8.2c-3,0-5.5-2.5-5.5-5.5v-5.5h19.2v5.5ZM482.9,509c0,3-2.5,5.5-5.5,5.5h-8.2c-3,0-5.5-2.5-5.5-5.5v-5.5h19.2v5.5ZM495.3,492.5c0,3-2.5,5.5-5.5,5.5H165.3c-3,0-5.5-2.5-5.5-5.5v-38.5h335.5v38.5ZM495.3,283.5h0v165H159.8V152.9h335.5v130.6ZM495.3,147.4H159.8v-56.4c0-3,2.5-5.5,5.5-5.5h324.5c3,0,5.5,2.5,5.5,5.5v56.4Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M159.8,492.5c0,3,2.5,5.5,5.5,5.5h324.5c3,0,5.5-2.5,5.5-5.5v-38.5H159.8v38.5Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "159.8 152.9 159.8 283.5 159.8 448.5 495.2 448.5 495.2 283.5 495.2 152.9 159.8 152.9"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M275.2,121.2h104.5c2.3,0,4.1-1.8,4.1-4.1,0-2.3-1.8-4.1-4.1-4.1h-104.5c-2.3,0-4.1,1.8-4.1,4.1,0,2.3,1.8,4.1,4.1,4.1Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M379.7,107.5h-104.5c-5.3,0-9.6,4.3-9.6,9.6s0,0,0,0c0,5.3,4.3,9.6,9.6,9.6h104.5c5.3,0,9.6-4.3,9.6-9.6,0,0,0,0,0,0,0-5.3-4.3-9.6-9.6-9.6ZM379.7,121.3h-104.5c-2.3,0-4.1-1.8-4.1-4.1s0,0,0,0c0-2.3,1.8-4.1,4.1-4.1h104.5c2.3,0,4.1,1.8,4.1,4.1,0,0,0,0,0,0,0,2.3-1.8,4.1-4.1,4.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishwasher);
export default __webpack_public_path__ + "static/media/dishwasher.c016df99497f4d9f59328c34f906db75.svg";
export { ForwardRef as ReactComponent };